import React from 'react';
import { Link, useLocation, Outlet } from 'react-router-dom';
import { Home, Users, ShoppingBag, MessageCircle, User } from 'lucide-react';
import { useAuthStore } from '../store/authStore';
import { cn } from '../lib/utils';
import UserName from './UserName';
import VerifiedBadge from './VerifiedBadge';

interface MobileLayoutProps {
  hideNav?: boolean;
}

function MobileLayout({ hideNav = false }: MobileLayoutProps) {
  const location = useLocation();
  const { user } = useAuthStore();

  const navigation = [
    { name: 'Home', icon: Home, href: '/' },
    { name: 'Communities', icon: Users, href: '/communities' },
    { name: 'Marketplace', icon: ShoppingBag, href: '/marketplace' },
    { name: 'Messages', icon: MessageCircle, href: '/messages' },
    { name: 'Profile', icon: User, href: '/profile' },
  ];

  return (
    <div className="min-h-screen bg-surface font-dillan text-neutral-50">
      {/* Main Content */}
      <main className={cn(
        "min-h-screen",
        !hideNav && "pb-20"
      )}>
        <Outlet />
      </main>
      
      {/* Bottom Navigation */}
      {!hideNav && (
        <nav className="fixed bottom-0 left-0 right-0 z-50">
          <div className="bg-primary border-t border-primary backdrop-blur-lg">
            <div className="h-20 px-6 pt-2 pb-6">
              <div className="grid grid-cols-5 gap-1 h-full">
                {navigation.map((item) => {
                  const Icon = item.icon;
                  const isActive = location.pathname === item.href;
                  const isProfile = item.name === 'Profile';
                  return (
                    <Link
                      key={item.name}
                      to={item.href}
                      className={cn(
                        'flex flex-col items-center justify-center gap-1.5 rounded-xl transition-all duration-200 text-xs font-dillan font-medium',
                        isActive
                          ? 'text-primary hover:text-primary bg-surface shadow-elevation-1'
                          : 'text-surface-light hover:text-primary-light'
                      )}
                    >
                      <div className="relative">
                        <Icon
                          className={cn(
                            'w-8 h-8 flex-shrink-0',
                            isActive 
                          )}
                        />
                        {isProfile && user?.verified && (
                          <VerifiedBadge 
                            size="sm" 
                            className="absolute -top-1 -right-1"
                          />
                        )}
                      </div>
                    </Link>
                  );
                })}
              </div>
            </div>
          </div>
        </nav>
      )}
    </div>
);
}

export default MobileLayout;